import { API } from "../utils";

export const getProjects = async ({ params }) => {
  const response = API.get("/organization/projects", { params });
  const data = await response;
  return data;
};

export const getProjectsExcel = async ({ params }) => {
  const response = API.get("/organization/projects/excel/export", { params });
  const data = await response;
  return data;
};

export const createProject = async ({ body }) => {
  const response = API.post("/organization/projects", body);
  const data = await response;
  return data;
};

export const deleteProject = async ({ params }) => {
  const response = API.delete(`/organization/projects/${params.id}`, { params });
  const data = await response;
  return data;
};

export const getProject = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}`, { params });
  const data = await response;
  return data;
};

export const getProjectDashboard = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/dashboard`, { params });
  const data = await response;
  return data;
};

export const getProjectReports = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/reports`, {
    params,
  });
  const data = await response;
  return data;
};

export const getProjectActivities = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/activities`, { params });
  const data = await response;
  return data;
};

export const getProjectActivitiesExcel = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/activities/excel/export`, { params });
  const data = await response;
  return data;
};

export const updateProject = async ({ params, body }) => {
  const response = API.patch(`/organization/projects/${params.id}`, body);
  const data = await response;
  return data;
};

export const restoreProject = async ({ params }) => {
  const response = API.put(`/organization/projects/${params.id}/restore`);
  const data = await response;
  return data;
};

export const updateProjectStatus = async ({ params, body }) => {
  const response = API.put(`/organization/projects/${params.id}/status`, body);
  const data = await response;
  return data;
};

export const updateTaskStatus = async ({ params, body }) => {
  const response = API.put(`/organization/projects/${params.id}/tasks/${params.task}/status`, body);
  const data = await response;
  return data;
};

export const getProjectSteps = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/steps`);
  const data = await response;
  return data;
};

export const getProjectKanban = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/kanban`, { params });
  const data = await response;
  return data;
};

export const searchProjectTasks = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/tasks/search`, {
    params: { search: params.search, per_page: params.per_page },
  });
  const data = await response;
  return data;
};

export const getProjectTasks = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/tasks`, { params });
  const data = await response;
  return data;
};

export const updateProjectTask = async ({ params, body }) => {
  const response = API.patch(`/organization/projects/${params.id}/tasks/${params.task}`, body);
  const data = await response;
  return data;
};

export const getProjectSingleTask = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/tasks/${params.task}`);
  const data = await response;
  return data;
};

export const getProjectSingleTaskComments = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/tasks/${params.task}/comments`);
  const data = await response;
  return data;
};

export const updateProjectSingleTaskComment = async ({ params, body }) => {
  const response = API.post(`/organization/projects/${params.project}/tasks/${params.task}/comments/${params.comment}`, body);
  const data = await response;
  return data;
};

export const deleteTaskComment = async ({ params, body }) => {
  const response = API.delete(`/organization/projects/${params.project}/tasks/${params.task}/comments/${params.comment}`);
  const data = await response;
  return data;
};

export const getProjectSingleTaskActivities = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/tasks/${params.task}/activities`);
  const data = await response;
  return data;
};

export const moveProjectSingleTask = async ({ params, body }) => {
  const response = API.put(`/organization/projects/${params.id}/tasks/${params.task}/move`, body);
  const data = await response;
  return data;
};

export const createProjectTask = async ({ params, body }) => {
  const response = API.post(`/organization/projects/${params.id}/tasks`, body);
  const data = await response;
  return data;
};

/* One request per pasted list rather than one per line — see TaskController's
 * storeBulk. Body: { step_id, titles: [], parent_id?, start_at? }. */
export const createProjectTasksBulk = async ({ params, body }) => {
  const response = API.post(`/organization/projects/${params.id}/tasks/bulk`, body);
  const data = await response;
  return data;
};

export const createProjectTaskComment = async ({ params, body }) => {
  const response = API.post(`/organization/projects/${params.id}/tasks/${params.task}/comments`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const data = await response;
  return data;
};

export const deleteProjectTask = async ({ params }) => {
  const response = API.delete(`/organization/projects/${params.id}/tasks/${params.task}`);
  const data = await response;
  return data;
};

export const cloneProjectTask = async ({ params, body }) => {
  const response = API.put(`/organization/projects/${params.id}/tasks/${params.task}/clone`, body);
  const data = await response;
  return data;
};

export const updateProjectSteps = async ({ params, body }) => {
  const response = API.post(`/organization/projects/${params.id}/steps`, body);
  const data = await response;
  return data;
};

export const updateProjectStep = async ({ params, body }) => {
  const response = API.post(`/organization/projects/${params.id}/steps/${params.step}`, body);
  const data = await response;
  return data;
};

export const uploadProjectMedia = async ({ params, body, onUploadProgress }) => {
  const response = API.post(`/organization/projects/${params.project}/media`, body, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress,
    timeout: 120000,
  });
  const data = await response;
  return data;
};

export const deleteProjectMedia = async ({ params }) => {
  const response = API.delete(`/organization/projects/${params.project}/media/${params.media}`);
  const data = await response;
  return data;
};

export const deleteScheduledTask = async ({ params }) => {
  const response = API.delete(`/organization/projects/${params.id}/scheduled_tasks/${params.task}`);
  const data = await response;
  return data;
};

export const addScheduledTask = async ({ params, body }) => {
  const response = API.post(`/organization/projects/${params.id}/scheduled_tasks`, body);
  const data = await response;
  return data;
};

export const getScheduledTask = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/scheduled_tasks`, { params });
  const data = await response;
  return data;
};

export const getSingleScheduledTask = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/scheduled_tasks/${params.task}`);
  const data = await response;
  return data;
};

export const updateScheduledTask = async ({ params, body }) => {
  const response = API.patch(`/organization/projects/${params.id}/scheduled_tasks/${params.task}`, body);
  const data = await response;
  return data;
};

export const putRestoreTask = async ({ params }) => {
  const response = API.put(`/organization/projects/${params.project}/tasks/${params.task}/restore`);
  const data = await response;
  return data;
};

export const updateRecordTime = async ({ params, body }) => {
  const response = API.patch(`/organization/time-tracking/${params.id}`, body);
  const data = await response;
  return data;
};

export const deleteRecordTime = async ({ params, body }) => {
  const response = API.delete(`/organization/time-tracking/${params.id}`);
  const data = await response;
  return data;
};

export const getCurrentRecordTime = async () => {
  const response = API.get(`/organization/time-tracking/current`);
  const data = await response;
  return data;
};

export const createRecordTime = async ({ params, body }) => {
  const response = API.post(`/organization/time-tracking`, body);
  const data = await response;
  return data;
};

export const getTasksExcel = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/tasks/excel/export`, { params });
  const data = await response;
  return data;
};

export const getProjectViews = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/views`, { params });
  const data = await response;
  return data;
};

export const getProjectView = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/views/${params.view_id}`, { params });
  const data = await response;
  return data;
};

export const storeProjectView = async ({ params, body }) => {
  const response = API.post(`/organization/projects/${params.id}/views`, body);
  const data = await response;
  return data;
};

export const updateProjectView = async ({ params, body }) => {
  const response = API.patch(`/organization/projects/${params.id}/views/${params.view_id}`, body);
  const data = await response;
  return data;
};

export const deleteProjectView = async ({ params }) => {
  const response = API.delete(`/organization/projects/${params.id}/views/${params.view_id}`);
  const data = await response;
  return data;
};

export const getProjectDocs = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/docs`, { params });
  const data = await response;
  return data;
};

export const getProjectDoc = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/docs/${params.doc_id}`);
  const data = await response;
  return data;
};

export const storeProjectDoc = async ({ params, body }) => {
  const response = API.post(`/organization/projects/${params.id}/docs`, body);
  const data = await response;
  return data;
};

export const updateProjectDoc = async ({ params, body }) => {
  const response = API.patch(`/organization/projects/${params.id}/docs/${params.doc_id}`, body);
  const data = await response;
  return data;
};

export const deleteProjectDoc = async ({ params }) => {
  const response = API.delete(`/organization/projects/${params.id}/docs/${params.doc_id}`);
  const data = await response;
  return data;
};

export const getProjectSprints = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.id}/sprints`, {
    params,
  });
  const data = await response;
  return data;
};

export const getProjectSprint = async ({ params }) => {
  const response = API.get(
    `/organization/projects/${params.id}/sprints/${params.sprint}`,
  );
  const data = await response;
  return data;
};

export const createProjectSprint = async ({ params, body }) => {
  const response = API.post(
    `/organization/projects/${params.id}/sprints/custom`,
    body,
  );
  const data = await response;
  return data;
};

export const generateProjectSprints = async ({ params, body }) => {
  const response = API.post(
    `/organization/projects/${params.id}/sprints`,
    body,
  );
  const data = await response;
  return data;
};

export const extendProjectSprints = async ({ params, body }) => {
  const response = API.post(
    `/organization/projects/${params.id}/sprints/add-until`,
    body,
  );
  const data = await response;
  return data;
};

export const updateProjectSprint = async ({ params, body }) => {
  const response = API.patch(
    `/organization/projects/${params.id}/sprints/${params.sprint}`,
    body,
  );
  const data = await response;
  return data;
};

export const deleteProjectSprint = async ({ params }) => {
  const response = API.delete(
    `/organization/projects/${params.id}/sprints/${params.sprint}`,
  );
  const data = await response;
  return data;
};

export const syncProjectSprintTasks = async ({ params, body }) => {
  const response = API.post(
    `/organization/projects/${params.id}/sprints/${params.sprint}/tasks`,
    body,
  );
  const data = await response;
  return data;
};

/* تنظیمات پرتال یک پروژه: کدام ستون‌ها برای مشتری دیده شوند و نمودار روند
 * نمایش داده شود یا نه. */
export const getProjectPortalSettings = async ({ params }) => {
  const response = API.get(`/organization/projects/${params.uuid}/portal`);
  const data = await response;
  return data;
};

export const saveProjectPortalSettings = async ({ params, body }) => {
  const response = API.patch(
    `/organization/projects/${params.uuid}/portal`,
    body
  );
  const data = await response;
  return data;
};
